export default "__VITE_ASSET__sSUDsS2s__"